import React from "react";
import { PageHeader } from "./PageHeader";

export const Proceedings = props => {
  return (
    <React.Fragment>
      <PageHeader title="Materiały pokonferencyjne" />
      <div className="content-wrapper">
        <div className="main-content page-gallery">
            <div className="main-content proceedings">
                <div>
                    <img src="http://static.epnp.pl/public/thumbnail/publication/0000/8747/800/A08115_APPBPS_5_3.jpg" className="img-responsive mypic" alt="ActaPhysicsPolonicaB"/>
                </div>

                <div className="book-info">
                    <div className="text-center mt-2">
                        <strong>Materiały po konferencyjne zostaną opublikowane w recenzowanym czasopiśmie naukowym <br/>
                            <a href="http://www.actaphys.uj.edu.pl/"><span>Acta Physics Polonica B - Proceedings Supplement</span></a>.</strong>
                    </div>
                    <br/>
                    <h5>Instrukcje dotycząca przygotowania artykułow pokonferencyjnych:</h5>
                    <ol>
                        <li>Do publikacji materiałów zaproszeni są wszyscy wykładowcy oraz osoby prezentujące
                            plakaty naukowe podczas 45. Zjazdu Fizyków Polskich.</li>
                        <li>Prace należy przygotowac w języku angielskim.</li>
                        <li>Sugerowana objętość komunikatu do 6. stron w druku, natomiast referaty zaproszone i plenarne do 12. stron. </li>
                        <li>Artykuły należy przygotować w formacie LaTeX zgodnie z zasadami publikacji Acta Physica Polonica B: <a href="https://www.actaphys.uj.edu.pl/for_authors/">https://www.actaphys.uj.edu.pl/for_authors/</a></li>
                        <li>Prace należy przesłać w postaci spakowanego archiwum (np. ZIP, RAR)  uwaględniajac wszystkie niezbędne pliki na adres email: <a href="mailto:45ZFP.program@uj.edu.pl">45ZFP.program@uj.edu.pl</a></li>
                        <li>W tytule wiadomości należy wpisać: nr sesji (lub nr plakatu)_nazwisko_pierwszego_autora Numer sesji (lub numer plakatu) powinien być zgodny z numeracją w książce abstraktów.</li>
                        <li>Ostateczny termin nadsyłania prac: <s>15. stycznia 2020 r.</s> <span>przedłużono do 17 lutego 2020 r.</span></li>
                        <li>Wszystkie przesłane do publikacji artykuły będą recenzowane, nazwiska recenzentów nie będą ujawniane autorom prac.</li>
                        <li>Ostateczną decyzję o publikowaniu lub odrzuceniu pracy podejmuje Komitet Wydawniczy materiałów pokonferencyjnych 45.ZFP oraz Redakcja Acta Physica Polonica B.</li>
                        <li>W wyjątkowych przypadkach Komitet Wydawniczy zastrzega sobie możliwość nieujawniania recenzji.</li>
                        <li>Osoba przesyłająca materiały do publikacji proszona jest o wydrukowanie i podpisanie regulaminu (do pobrania)
                            w imieniu wszystkich współautorów. Prosimy o przesłanie skanu podpisanego regulaminu wraz z pracą na adres: 45ZFP.program@uj.edu.pl</li>
                    </ol>
                </div>
            </div>
        </div>
      </div>
    </React.Fragment>
  );
};

Proceedings.propTypes = {};
